var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',[_c('g-alert',{attrs:{"message":_vm.alertBannerMessage,"type":_vm.alertBannerType,"identifier":_vm.alertBannerIdentifier}}),_c('router-view',{key:_vm.key})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }